/**
 * Tenant portalLogo — session cache + Portal API fetch (same-origin safe)
 */

const CACHE_PREFIX = 'iampam_portal_logo:';

export function getCachedPortalLogo(tenantId: string): string | undefined {
  try {
    const value = sessionStorage.getItem(`${CACHE_PREFIX}${tenantId}`);
    return value && value.length > 0 ? value : undefined;
  } catch {
    return undefined;
  }
}

export function setCachedPortalLogo(tenantId: string, logo: string): void {
  try {
    const trimmed = logo.trim();
    if (trimmed) sessionStorage.setItem(`${CACHE_PREFIX}${tenantId}`, trimmed);
  } catch {
    // ignore
  }
}

export function clearCachedPortalLogo(tenantId?: string): void {
  try {
    if (tenantId) {
      sessionStorage.removeItem(`${CACHE_PREFIX}${tenantId}`);
      return;
    }
    for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(CACHE_PREFIX)) sessionStorage.removeItem(key);
    }
  } catch {
    // ignore
  }
}

/** 프로덕션 portalApiUrl='' → 같은 오리진 `/api/portal/...` */
export function buildPortalTenantLogoUrl(tenantId: string, portalApiUrl?: string): string {
  const encoded = encodeURIComponent(tenantId);
  const path = `/api/portal/admin/tenants/${encoded}`;
  const base = (portalApiUrl ?? '').trim().replace(/\/$/, '');
  if (!base) return path;
  if (base.endsWith('/api/portal')) return `${base}/admin/tenants/${encoded}`;
  return `${base}/api/portal/admin/tenants/${encoded}`;
}

export async function fetchTenantPortalLogo(
  tenantId: string,
  token: string,
  portalApiUrl?: string,
): Promise<string | undefined> {
  const response = await fetch(buildPortalTenantLogoUrl(tenantId, portalApiUrl), {
    headers: {
      Authorization: `Bearer ${token}`,
      'X-Tenant-Id': tenantId,
    },
  });
  if (!response.ok) return undefined;
  const tenant = await response.json();
  const logo = tenant?.metadata?.portalLogo;
  return typeof logo === 'string' && logo.trim().length > 0 ? logo.trim() : undefined;
}
